import ChipListComponent from '../ChipListComponent';
import * as React from 'react';
import { FormEvent, useEffect, useState } from 'react';
import TextFieldComponent from '../TextFieldComponent';
import { Grid2 } from '@mui/material';
import ButtonComponent from '../ButtonComponent';
import { Check, PhoneAndroid } from '@mui/icons-material';

interface WhatsAppSelectComponentProps {
  onChange?: (value: string[]) => void;
  value?: string[];
  gridSize?: number;
  whatsAppChipGridSize?: number;
}

const WhatsAppSelectComponent = ({
  onChange,
  whatsAppChipGridSize = 12,
  gridSize = 6,
  value,
}: WhatsAppSelectComponentProps) => {
  const [selectedWhastApp, setselectedWhastApp] = useState<string[]>([]);
  const [whastApp, setWhastApp] = useState<string>('');

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    setselectedWhastApp((oldState) => [...oldState, whastApp]);
    setWhastApp('');
    if (onChange) onChange([...selectedWhastApp, whastApp]);
  };

  useEffect(() => {
    if (value) setselectedWhastApp(value);
  }, [value]);
  return (
    <>
      <Grid2 size={gridSize}>
        <form style={{ display: 'flex' }} onSubmit={handleSubmit}>
          <TextFieldComponent
            value={whastApp}
            onChangeText={setWhastApp}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderBottomRightRadius: 0,
                  borderTopRightRadius: 0,
                },
              },
            }}
            label={'Números de WhatsApp para notificações'}
          />
          <ButtonComponent
            type="submit"
            disabled={!whastApp.trim()}
            sx={{
              mb: 3,
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0,
              height: '70%',
            }}
          >
            <Check />
          </ButtonComponent>
        </form>
      </Grid2>
      {selectedWhastApp && selectedWhastApp.length > 0 && (
        <Grid2 size={whatsAppChipGridSize} sx={{ mb: 1 }}>
          <ChipListComponent
            chipIcon={<PhoneAndroid />}
            chipData={selectedWhastApp}
            maxChipWidth={250}
            onDelete={(index) => {
              const newVal = selectedWhastApp.filter((_, i) => i !== index);
              if (onChange) onChange(newVal);
              setselectedWhastApp(newVal);
            }}
          />
        </Grid2>
      )}
    </>
  );
};

export default WhatsAppSelectComponent;
